"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledMultiSelectField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_component_library_1 = require("@esub-engineering/react-component-library");
var react_hook_form_1 = require("react-hook-form");
// TODO: this should be a module or inside the render, bad practice otherwise
function isMultiSelectOption(object) {
    return object.value !== undefined;
}
exports.ControlledMultiSelectField = react_1.default.memo(function (_a) {
    var label = _a.label, options = _a.options, control = _a.control, disabled = _a.disabled, limitTags = _a.limitTags, canAddOptions = _a.canAddOptions, rest = __rest(_a, ["label", "options", "control", "disabled", "limitTags", "canAddOptions"]);
    var _b = (0, react_hook_form_1.useController)({
        name: rest.name,
        control: control,
    }), _c = _b.field, onChange = _c.onChange, value = _c.value, inputProps = __rest(_c, ["onChange", "value"]), _d = _b.fieldState, invalid = _d.invalid, error = _d.error;
    var validationProps = {
        error: invalid,
        helperText: invalid ? error === null || error === void 0 ? void 0 : error.message : rest.helperText,
    };
    var mappedValue = value === null || value === void 0 ? void 0 : value.map(function (name) {
        if (isMultiSelectOption(name))
            return name;
        var option = options.find(function (optionToCheck) { return optionToCheck.value === name; });
        // TODO: this is a workaround just to avoid an app crash trying to find
        // default values that doesn't exist on received options
        return option || { value: name, text: name };
    });
    return ((0, jsx_runtime_1.jsx)(react_component_library_1.MultiSelect, __assign({}, rest, inputProps, validationProps, { disabled: disabled, onChange: onChange, label: label, limitTags: limitTags, options: options, canAddOptions: canAddOptions, defaultValue: mappedValue, disablePortal: true, positionStatic: true })));
});
